import React from 'react';
import { Modal } from '@spotify-internal/anchor-ds';
import { ButtonPrimary, ButtonSecondary } from '@spotify-internal/encore-web';

export function ConfirmationModal({
  onCancel,
  onConfirm,
  action,
}: {
  onCancel: () => void;
  onConfirm: () => void;
  action?: 'delete' | 'end';
}) {
  if (!action) return null;
  return (
    <Modal
      isShowing
      isShowingCloseButton
      onClose={onCancel}
      aria-labelledby="interactive-confirmation-poll-title"
    >
      <Modal.Title id="interactive-confirmation-poll-title">
        Are you sure you want to {action} this poll?
      </Modal.Title>
      <Modal.Body>
        {action === 'delete'
          ? "If you delete this poll, we won't be able to recover it."
          : 'You can always republish this poll at a later date.'}
      </Modal.Body>
      <Modal.Footer>
        <ButtonSecondary onClick={onCancel}>Cancel</ButtonSecondary>
        <ButtonPrimary onClick={onConfirm}>
          Yes, {action} this poll
        </ButtonPrimary>
      </Modal.Footer>
    </Modal>
  );
}
